// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"b13e250e","442":"77acfade"}[chunkId] + ".chunk.js";
};